import { Shape2Icon } from '../components/Shape2/Shape2';
import { EditGroupFieldErrorsData } from '../service/GroupEditErrors/ClientGroupEditErrors/ClientGroupEditErrors';

import { DictionaryItem } from './common';
import { CampaignId, CampaignsCalcTypeFilter, CampaignType, GroupType } from './domain';
import { CurrencyCode, GdStringDictName } from './graphql-grid';
import { EditGroupData } from './groupsEditState';

export type GroupId = string;

export enum SmartGroupBudgetCalculation {
    AUTO = 'auto',
    FULL = 'full',
    CPC = 'cpc'
}

export enum GdAdGroup {
    GdCpmAudioAdGroup = 'GdCpmAudioAdGroup',
    GdCpmBannerAdGroup = 'GdCpmBannerAdGroup',
    GdCpmGeoproductAdGroup = 'GdCpmGeoproductAdGroup',
    GdCpmIndoorAdGroup = 'GdCpmIndoorAdGroup',
    GdCpmOutdoorAdGroup = 'GdCpmOutdoorAdGroup',
    GdCpmVideoAdGroup = 'GdCpmVideoAdGroup',
    GdDynamicAdGroup = 'GdDynamicAdGroup',
    GdInternalAdGroup = 'GdInternalAdGroup',
    GdMcBannerAdGroup = 'GdMcBannerAdGroup',
    GdMobileContentAdGroup = 'GdMobileContentAdGroup',
    GdSmartAdGroup = 'GdSmartAdGroup',
    GdTextAdGroup = 'GdTextAdGroup'
}

export interface TypeModeGroup {
    groupType: GroupType;
    restrictionId: string;
}
export interface TypeModeGroupItems {
    val: string;
    text: string;
    createdText: string;
    active: boolean;
    hidden?: boolean;
    beta?: boolean;
    groupType: GroupType;
    icon: Shape2Icon;
}

export enum SmartGroupPerformanceFilterType {
    CATEGORIES = 'categories',
    CONDITIONS = 'conditions'
}

export enum DuplicateRadioControlType {
    ACTUAL_CAMPAIGN = 'ACTUAL_CAMPAIGN',
    ANOTHER_CAMPAIGN = 'ANOTHER_CAMPAIGN'
}

export interface DuplicateItem {
    groupName: string;
    campaignName: string;
    groupId: string;
    campaignId: string;
    isInvalid: boolean;
    isDisabled: boolean;
    campaignType: CampaignType;
}

export enum DuplicateGroupsModalViewState {
    duplicate = 'copy',
    selectCampaign = 'selectCampaign'
}

export interface ContentPromotionDuplicateValidationResults {
    distinctTypeFromExistingIdxList?: string[];
}

export interface DuplicateValidationResults {
    copyErrorLimitIdxList: string[];
    copyErrorsBrokenGroupsIdxList: string[];
    contentPromotionErrors: ContentPromotionDuplicateValidationResults;
}

export enum GroupsScreenUrlSearchQueryParams {
    campaignsIds = 'campaigns-ids',
    groupsIds = 'groups-ids',
    isNew = 'is-new',
    isNewEmptyGroup = 'is-new-empty-group',
    ulogin = 'ulogin'
}

export enum BannersEditMassActionItemType {
    turbo = 'turbo',
    tracking = 'tracking',
    visibleDomain = 'visibleDomain',
    visibleLinkReplace = 'visibleLinkReplace',
    textPathReplace = 'textPathReplace',
    link = 'link',
    linkReplace = 'linkReplace',
    ageLimit = 'ageLimit',
    childAgeLimit = 'childAgeLimit',
    callouts = 'callouts',
    video = 'video',
    image = 'image',
    videoCreative = 'videoCreative',
    cpmVideoCreative = 'cpmVideoCreative',
    audioCreative = 'audioCreative',
    siteLinks = 'siteLinks',
    bannerPrice = 'bannerPrice',
    imageCreative = 'imageCreative',
    cpmImageCreative = 'cpmImageCreative',
    counters = 'counters',
    pixel = 'pixel'
}

export enum GroupsEditMassActionItemType {
    minusPhrase = 'minusPhrase'
}

export interface BannersEditMassActionItem {
    type: BannersEditMassActionItemType;
    text: React.ReactNode;
    val: string;
    disabled?: boolean;
    hidden?: boolean;
}

export type BannersEditMassActionGroup = {
    title?: string;
    items: Array<BannersEditMassActionItem>;
};

export type BannersEditMassActionItems = Array<BannersEditMassActionGroup>;

export type StringDictsItems = Partial<Record<GdStringDictName, DictionaryItem[]>>;

export interface GroupsEditMassActionItem {
    type: GroupsEditMassActionItemType;
    text: React.ReactNode;
    val: string;
    disabled?: boolean;
    hidden?: boolean;
}

export type GroupsEditMassActionGroup = {
    title?: string;
    items: Array<GroupsEditMassActionItem>;
};

export type GroupsEditMassActionItems = Array<GroupsEditMassActionGroup>;

export interface ProductFilterInput {
    campaignId?: CampaignId;
    calcType: CampaignsCalcTypeFilter;
    type: CampaignType;
    currency: CurrencyCode;
}

export type EditGroupErrorsRecord = Record<GroupId, Record<string, EditGroupFieldErrorsData>>;

export enum GroupsCategories {
    textAdd = 'textAdd',
    textUpdate = 'textUpdate',
    smartUpdate = 'smartUpdate',
    mcBannerUpdate = 'mcBannerUpdate',
    contentPromotionAdd = 'contentPromotionAdd',
    contentPromotionUpdate = 'contentPromotionUpdate'
}

export interface GroupsTypeMap {
    text: Array<EditGroupData>;
    smart: Array<EditGroupData>;
    mcBanner: Array<EditGroupData>;
    contentPromotion: Array<EditGroupData>;
}

export interface GroupsStateMap {
    added: Array<EditGroupData>;
    updated: Array<EditGroupData>;
}

export interface GroupsScreenAsideLinks {
    autotargeting: string;
    geotargeting: string;
    keyPhrases: string;
    minusPhrases: string;
    retargeting: string;
    bidsAdjustment: string;
    filters: string;
    manageFeeds: string;
    utmParameters: string;
    feedFieldTitle: string;
    feedFieldBody: string;
}

export enum MobileContentOsType {
    IOS = 'IOS',
    ANDROID = 'ANDROID'
}
